import { Event } from '@platform/client/schemas';
import { Icon } from '@platform/components';
import { CommunityCard } from '../CommunityCard';

type EventCardProps = {
  event: Event;
};

export const EventCard = (props: EventCardProps) => {
  const { event } = { ...props };
  const timeRange =
    new Date(event.startTime).toLocaleTimeString('default', {
      timeZone: event.timezone,
      hour12: true,
      hour: '2-digit',
      minute: '2-digit',
    }) +
    ' - ' +
    new Date(event.startTime).toLocaleTimeString('default', {
      timeZone: event.timezone,
      hour12: true,
      hour: '2-digit',
      minute: '2-digit',
    }) +
    ' ' +
    new Date(event.endTime)
      .toLocaleDateString('default', {
        day: '2-digit',
        hour12: true,
        timeZoneName: 'short',
        timeZone: event.timezone,
      })
      .substring(4); //Isolate the timezone component. Date objects are weird

  return (
    <CommunityCard
      title={event.title}
      date={new Date(event.startTime)}
      subheader={
        <div>
          <div className='hidden md:flex gap-1 justify-left items-center text-sm'>
            <Icon size='16' type='clock' />
            {timeRange}&nbsp;•&nbsp;Hosted by {event.hostedBy}
          </div>
          <div className='flex flex-col md:hidden justify-start items-left text-sm'>
            <div className='flex flex-row justify-start gap-1'>
              <Icon size='16' type='clock' additionalClassNames='mt-0.5' />
              {timeRange}
            </div>
            <div className='text-sm'>Hosted by {event.hostedBy}</div>
          </div>
        </div>
      }
      description={event.description}
      link={event.link ?? undefined}
    />
  );
};
